export { default } from "./WishlistProducts.jsx";
